module.exports = __webpack_public_path__ + "static/media/inherit-img7.50d63b3a.png";